import React, { useRef, useEffect } from 'react';
import { Animated, Dimensions, Easing, ScrollView } from 'react-native';

import { ViewPropTypes } from 'deprecated-react-native-prop-types';
import { isFunction as _isFunction, isNil as _isNil } from 'lodash';
import PropTypes from 'prop-types';

import { getRTLValue } from '../../Utils/RTL';
import { useTheme, LightThemeColors } from '../Themes';

import TabItem from './TabItem';
import styles from './VFHeaderTabs.styles';

function VFHeaderTabsScrollable({
  activeTab,
  setActiveTab,
  tabs,
  allowFontScaling,
  activeTabTextStyle,
  inActiveTabTextStyle,
}) {
  const lineWidthAnimation = useRef(
    new Animated.Value(Dimensions.get('window').width / (tabs?.length ?? 1)),
  );
  const lineTranslateAnimation = useRef(
    new Animated.Value(Dimensions.get('window').width / (2 * (tabs?.length ?? 1))),
  );
  const tabsWidth = useRef(Array.from({ length: tabs?.length ?? 0 })).current;
  const theme = useTheme() || LightThemeColors;

  useEffect(() => {
    !_isNil(activeTab) && handleLineAnimation();
  }, [activeTab]);

  const handleOnPress = index => {
    _isFunction(setActiveTab) && setActiveTab(index);
    handleLineAnimation();
  };

  const handleLineAnimation = () => {
    if (tabsWidth.includes(undefined)) {
      return;
    }

    Animated.parallel([
      Animated.timing(lineWidthAnimation.current, {
        toValue: tabsWidth[activeTab],
        duration: 200,
        easing: Easing.linear,
        useNativeDriver: true,
      }),
      Animated.timing(lineTranslateAnimation.current, {
        toValue: getRTLValue(
          tabsWidth.reduce((a, b, i) => (i < activeTab ? a + b : a), 0) + tabsWidth[activeTab] / 2,
        ),
        duration: 200,
        easing: Easing.linear,
        useNativeDriver: true,
      }),
    ]).start();
  };

  function setTabWidth(index, nativeEvent) {
    tabsWidth[index] = nativeEvent.layout.width;
    handleLineAnimation();
  }

  const tabsList =
    tabs && tabs.length
      ? tabs.map((tab, i) => {
          return (
            <TabItem
              onTabLayout={({ nativeEvent }) => setTabWidth(i, nativeEvent)}
              key={tab.index}
              tabStyle={[styles.tab(theme), styles.tabScroll]}
              activeTab={activeTab}
              handleOnPress={handleOnPress}
              tab={tab}
              allowFontScaling={allowFontScaling}
              activeTextStyle={activeTabTextStyle}
              inActiveTextStyle={inActiveTabTextStyle}
            />
          );
        })
      : null;

  return (
    <ScrollView
      horizontal={true}
      showsHorizontalScrollIndicator={false}
      bounces={false}
      contentContainerStyle={[styles.container, styles.containerTopColor(theme)]}
    >
      {tabsList}
      <Animated.View
        style={[
          styles.activeLine,
          styles.activeLineScrollWidth,
          styles.activeTabBackgroundColorColor(theme),
          {
            transform: [
              { translateX: lineTranslateAnimation.current },
              { scaleX: lineWidthAnimation.current },
            ],
          },
        ]}
        usena
      />
    </ScrollView>
  );
}

VFHeaderTabsScrollable.defaultProps = {
  activeTab: 0,
  tabs: [],
  setActiveTab: () => {},
};

VFHeaderTabsScrollable.propTypes = {
  activeTab: PropTypes.number,
  setActiveTab: PropTypes.func,
  tabs: PropTypes.array,
  allowFontScaling: PropTypes.bool,
  activeTabTextStyle: ViewPropTypes.style,
  inActiveTabTextStyle: ViewPropTypes.style,
};

export default VFHeaderTabsScrollable;
